import { useHistory } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { Badge, Dropdown, Menu } from 'antd';

import {
    FileSyncOutlined,
    FileTextOutlined,
    FormOutlined,
} from '@ant-design/icons';

import useToggleActiveRibbon from './hook';

import RibbonButton from 'common/components/button/RibbonButton';

import { useSsoProductParams } from 'hooks/useSso';

import { getParamsFromUrl } from 'utils/common/route';

import { queryQaEvalFormKey } from 'pages/new-evaluation-form/hooks/useGetEvaluationForm';

import {
    getQaEvaluationFormDetail,
    getQaEvaluationFormMultiPackDetail,
} from 'services/qaSpec';

import './QaEvaluationForm.less';

const QaEvaluationForm = ({ productData }) => {
    const history = useHistory();

    const { ssoParamUrl: ssoProductParams, productId } = useSsoProductParams();

    const { type } = getParamsFromUrl(history.location) ?? {};

    const queryClient = useQueryClient();

    const checkActiveContent = () => {
        const path = history?.location?.pathname;
        const search = history?.location?.search;
        const fullUrl = `${path}${search}`;

        const regex = /\/product\/evaluation\/\d+/;
        return regex.test(fullUrl);
    };

    const isPathActive = checkActiveContent();

    const isActive = useToggleActiveRibbon(isPathActive);

    const handlePrefetchEvaluationForm = (type) => {
        queryClient.prefetchQuery({
            queryKey: queryQaEvalFormKey(productData?.productId, type),
            queryFn: async () => {
                if (type == 'Multipack') {
                    const response = await getQaEvaluationFormMultiPackDetail({
                        productId: productData?.productId,
                        evaluationFormName: 'Multipack',
                    });
                    if (!response?.isSuccess) {
                    if (response?.message)
                    {
                        window.history.replaceState(null, "", '/products');
                        //window.history.go(-2)
                    }
                    throw new Error(response?.message ?? 'Something went wrong');
                    }
                    return response?.data ?? {};
                    }
                    
                    const response = await getQaEvaluationFormDetail({
                    productId: productData?.productId,
                    evaluationFormName: type,
                    });
                    return response?.data ?? {};
                },
                staleTime: 60 * 1000,
                onError: (err) => {
                
                        CustomNotification.error(err.message ?? 'Something went wrong');
                        forwardTo('/product/' + productId);
                    }
                });
            };
        
        

    const handleClick = (type) => {
        if (productData?.productId) {
            if (isActive) {
                if (ssoProductParams) {
                    history.push(`/product/${productId}/?${ssoProductParams}`);
                } else {
                    history.push(
                        `/product/evaluation/${productData?.productId}?type=${type}`
                    );
                }
            } else {
                if (ssoProductParams) {
                    history.push(
                        `/product/evaluation/${productData?.productId}/?${ssoProductParams}`
                    );
                } else {
                    history.push(
                        `/product/evaluation/${productData?.productId}?type=${type}`
                    );
                }
            }
        }

        handlePrefetchEvaluationForm(type);
    };

    const hasDraftEvaluationForm = false;

    if (hasDraftEvaluationForm) {
        return (
            <Badge
                count={1}
                color='#faad14'
                className={
                    hasDraftEvaluationForm
                        ? 'qa-evaluation-form__count-draft'
                        : ''
                }
            >
                <RibbonButton
                    icon={
                        hasDraftEvaluationForm ? (
                            <FileSyncOutlined style={{ height: 26 }} />
                        ) : (
                            <FileTextOutlined style={{ height: 26 }} />
                        )
                    }
                    label={'Evaluation Form'}
                    onClick={handleClick}
                    toggle={isPathActive}
                />
            </Badge>
        );
    }

    const menuOptions = () => (
        <Menu>
            <Menu.Item
                key='food'
                style={{
                    backgroundColor: 'inherit',
                }}
            >
                <RibbonButton
                    size='small'
                    icon={<FormOutlined />}
                    label={'Food'}
                    className='button-item-dropdown'
                    onClick={() => handleClick('Food')}
                    toggle={isPathActive && type?.toLowerCase() === 'food'}
                />
            </Menu.Item>
            <Menu.Item
                key='nonFood'
                style={{
                    backgroundColor: 'inherit',
                }}
            >
                <RibbonButton
                    size='small'
                    icon={<FormOutlined />}
                    label={'Non-Food'}
                    className='button-item-dropdown'
                    onClick={() => handleClick('Non-Food')}
                    toggle={isPathActive && type?.toLowerCase() === 'non-food'}
                />
            </Menu.Item>
            <Menu.Item
                key='Multipack'
                style={{
                    backgroundColor: 'inherit',
                }}
            >
                <RibbonButton
                    size='small'
                    icon={<FormOutlined />}
                    label='Multipack'
                    className='button-item-dropdown'
                    onClick={() => handleClick('Multipack')}
                    toggle={isPathActive && type?.toLowerCase() === 'multipack'}
                />
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={menuOptions} placement='bottomLeft' arrow>
            <RibbonButton
                icon={
                    isActive ? (
                        getButtonProps[type?.toLowerCase()]?.icon
                    ) : (
                        <FileTextOutlined />
                    )
                }
                label={
                    isActive
                        ? getButtonProps[type?.toLowerCase()]?.label
                        : 'Evaluation Form'
                }
                toggle={isActive ? isPathActive : false}
            />
        </Dropdown>
    );
};

const getButtonProps = {
    food: {
        icon: <FormOutlined />,
        label: 'Food',
    },
    'non-food': {
        icon: <FormOutlined />,
        label: 'Non Food',
    },
    multipack: {
        icon: <FormOutlined />,
        label: 'Multipack',
    },
};

export default QaEvaluationForm;
